import apiClient from './apiClient';

/**
 * Ticker returned by GET /tickers.
 * Matches backend schema after E1.1 (chain discriminator added).
 */
export interface Ticker {
  id: number;
  short_name: string;
  long_name: string;
  chain: 'polygon' | 'solana';
  precision: number;
}

/**
 * Fetch all tickers from the backend.
 * Normalises Strapi response shape (data[].attributes or flat objects).
 */
export const fetchTickers = async (): Promise<Ticker[]> => {
  const response = await apiClient.get('/tickers?pagination[pageSize]=100');
  const rawList: unknown[] = response.data?.data ?? response.data ?? [];

  return rawList.map((item: unknown) => {
    const raw = item as Record<string, unknown>;
    // TB-RULE-DATA-NORMALIZE: handle both Strapi nested and flat shapes
    const attrs = (raw?.attributes ?? raw?.data ?? raw) as Record<string, unknown>;
    return {
      id: Number(raw.id ?? attrs.id),
      short_name: String(attrs.short_name ?? ''),
      long_name: String(attrs.long_name ?? ''),
      chain: attrs.chain as 'polygon' | 'solana',
      precision: Number(attrs.precision ?? 0),
    };
  });
};
